import styled, { css } from 'styled-components';
import { device } from '../../../../../breakpoints';
import { darkCoolGrey, regularWhite, playTransitionEasing } from '../../../../../design-tokens';
import { playFontSize, playFontIcon } from '../../../../../typography/helpers';

export const Icon = styled.span`
    color: ${darkCoolGrey};
    margin-left: 10px;
    position: relative;
    transition: all 100ms ${playTransitionEasing};
    transform: scale(1) translateX(0);

    &:before {
        ${({ icon }) => playFontIcon(2.2, icon)}

        ${(props) =>
            props.active &&
            css`
                color: ${regularWhite};
            `}
    }
`;

export const StyledExpandCollapseButton = styled.button`
    ${playFontSize(2.2)}
    color: ${regularWhite};
    background: none;
    text-decoration: none;
    border: 2px solid transparent;
    cursor: pointer;
    padding: 6px 0 8px 8px;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    margin-bottom: 8px; /*space for outline on focus*/

    &:focus {
        border-color: ${regularWhite};
        outline: none;
    }

    &:active {
        border-color: transparent;
    }

    &:hover ${Icon} {
        transform: scale(1.2) translateX(0);
    }

    @media ${device.GteSmall} {
        margin-bottom: 5px;
    }

    @media ${device.GteMedium} {
        padding-bottom: 10px;
        margin-bottom: 10px;
    } 

    &.play_is-hidden,
    .no-js & {
        display: none;
    }

    .no-react &,
    .no-js & {
        display: none;
    }
`;
